"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSystemStates = void 0;
const getSystemStates = (state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.states) !== null && _a !== void 0 ? _a : []; };
exports.getSystemStates = getSystemStates;
